import React from 'react';

import ptvNewsVideo from '../../../../Assets/Linkages/SpaceOutreachFilm/PTV-News.mp4';

const CinemaAsCatalyst = () => (
  <section className="cinema-as-catalyst" aria-labelledby="cinema-as-catalyst-title">
    <div className="cinema-as-catalyst-inner">
      <div className="cinema-as-catalyst-copy">
        <p className="section-eyebrow">STORIES THAT MOVE PEOPLE</p>
        <h2 id="cinema-as-catalyst-title">Cinema as Catalyst</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          Beyond the Blue proves that cinema can do more than tell stories—it can drive
          understanding, ignite conversations, and inspire action. This project sets a bold example
          of how science and storytelling together can shape minds, spark movements, and create
          real-world impact.
        </p>
      </div>

      <div className="cinema-as-catalyst-video-frame">
        <video controls preload="metadata" playsInline aria-label="PTV News coverage of Beyond the Blue">
          <source src={ptvNewsVideo} type="video/mp4" />
          Your browser does not support embedded video playback.
        </video>
      </div>
    </div>
  </section>
);

export default CinemaAsCatalyst;
